import { FC } from 'react';

import { GridColumn, GridLayout, GridRow, VSpacing } from '@hh.ru/magritte-ui';

import { AdminHeader } from 'components/Admin/AdminHeader/AdminHeader';
import Nav from 'components/Admin/Nav/Nav';
import { PromoCodes as PromoCodesBody } from 'components/Admin/PromoCodes/PromoCodes';
import { PromoCodesTitle } from 'components/Admin/PromoCodes/PromoCodesTitle/PromoCodesTitle';

export const PromoCodesPage: FC = () => (
    <>
        <AdminHeader />
        <GridLayout>
            <GridRow>
                <GridColumn xs={4} s={8} m={12} l={12}>
                    <VSpacing default={24} />
                    <Nav />
                    <PromoCodesTitle />
                    <VSpacing default={24} />
                    <PromoCodesBody />
                </GridColumn>
            </GridRow>
        </GridLayout>
    </>
);
